
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import vSelect from "vue-select"

import api from "@/services/api"
import { Case, CaseDetails } from "@/types"
const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class CaseSearch extends Vue {
	@Prop()
	public currentCase!: Case;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	public caseSearch: string = "";
	public searchResults: Case[] = [];
	public selectedCase: Case | null = null;

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.searchResults = []
		} else {
			loading(true)
			let unfilteredResults = await api.caseSearch(search)
			let filteredResults = unfilteredResults.filter((item: Case) => item.id !== this.currentCase.id)

			this.searchResults = filteredResults
			loading(false)
		}
	}

	public valueChanged (newValue: Case | null) {
		if (newValue) {
			this.$emit("change", newValue.caseNumber)
		}
	}
}
